export const CatalogAccessMode = {
  PUBLIC: 'PUBLIC',
  RESTRICTED: 'RESTRICTED',
} as const;

export type CatalogAccessMode = typeof CatalogAccessMode[keyof typeof CatalogAccessMode];

export interface CatalogLineItem {
  productId: number;
  productName?: string;
  productCode?: string;
  unitPrice: number;
}

export interface Catalog {
  id: number;
  companyId: number;
  name: string;
  accessMode: CatalogAccessMode;
  createdUserId: number;
  updatedUserId?: number;
  createdDate: string;
  updatedDate?: string;
  deactivatedDate?: string;
  itemCount?: number;
  lineItems?: CatalogLineItem[];
  accessEmails?: string[];
}

export interface CatalogLineItemRequest {
  productId: number;
  unitPrice: number;
}

export interface CreateCatalogRequest {
  companyId: number;
  name: string;
  accessMode: CatalogAccessMode;
  lineItems: CatalogLineItemRequest[];
  accessEmails: string[];
}

export interface UpdateCatalogRequest {
  name: string;
  accessMode: CatalogAccessMode;
  lineItems: CatalogLineItemRequest[];
  accessEmails: string[];
}

export interface CatalogSearchParams {
  name?: string;
  includeArchived?: boolean;
  page?: number;
  size?: number;
}

// Client-facing slice of a catalog (GET /catalog-view/{id})
export interface CatalogViewItem {
  productId: number;
  productName: string;
  productCode?: string;
  unitPrice: number;
}

export interface CatalogView {
  id: number;
  name: string;
  // Current page of items, already narrowed by the search term
  items: CatalogViewItem[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface CatalogViewParams {
  search?: string;
  // 0-based
  page?: number;
  size?: number;
}

export interface CatalogCartItem {
  productId: number;
  productName?: string;
  productCode?: string;
  quantity: number;
  // null when the product was removed from the catalog
  unitPrice: number | null;
  available: boolean;
}

export interface CatalogCart {
  catalogId: number;
  items: CatalogCartItem[];
}

export interface CatalogCartItemRequest {
  productId: number;
  quantity: number;
}

export interface PreOrderItem {
  productId: number;
  productName?: string;
  productCode?: string;
  quantity: number;
  unitPrice: number;
}

export type PreOrderStatus = 'NEW' | 'CONFIRMED' | 'FULFILLED' | 'CANCELLED';

export interface PreOrder {
  id: number;
  catalogId: number;
  // Filled for the owner-side views only
  catalogName?: string;
  clientEmail?: string;
  clientName?: string;
  clientPhone?: string;
  status: PreOrderStatus;
  createdDate: string;
  total: number;
  items: PreOrderItem[];
  // Activity Groups created from this pre-order (empty until it is converted)
  activityGroupIds: number[];
}
